import { render, staticRenderFns } from "./AssetsCenter.vue?vue&type=template&id=536b93f7&scoped=true&"
import script from "./AssetsCenter.vue?vue&type=script&lang=js&"
export * from "./AssetsCenter.vue?vue&type=script&lang=js&"
import style0 from "./AssetsCenter.vue?vue&type=style&index=0&id=536b93f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b93f7",
  null
  
)

export default component.exports